<template>
  <div class="member-area-tab-logo-config-component">
    <div class="d-flex flex-column gap-4">
      <div class="mb-1">
        <h5 class="fs-14 text-semibold">Identificação da marca</h5>
        <small class="text-dark-40 fs-12">
          Utilize uma versão horizontal e fundo transparente para melhor
          visualização.
        </small>
      </div>
      <div class="row">
        <snow-input-file
          v-model="form.logo"
          isImage
          id="logo-image"
          title="Logotipo"
          class="col-lg-4"
          background-color="bg-1"
          dimensions="600x210"
        />
        <div class="col-lg-6 d-lg-flex d-none">
          <img src="@/assets/images/member-area/tab-logo.svg" />
        </div>
        <!-- <logo-mockup :image="form.logo" class="col-lg-6" /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
